const SUPER_ADMIN_TITLE = 'Tutor - Super Admin';
const SUPER_ADMIN_FAVICON = '/favicon-tutor.ico';

export function isSuperAdminPath(path = '') {
    const value = String(path || '');
    return (
        value === '/admin'
        || value.startsWith('/admin/')
        || value.startsWith('/super-admin')
        || value.startsWith('/editar-empresa')
        || value.startsWith('/personalizar-empresa')
    );
}

export function applySuperAdminBranding() {
    if (typeof document === 'undefined') return;

    document.title = SUPER_ADMIN_TITLE;

    const selectors = [
        'link[rel="icon"]',
        'link[rel="shortcut icon"]',
    ];

    let link = null;
    selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((node) => {
            if (!link) link = node;
            else node.parentNode?.removeChild(node);
        });
    });

    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
    }

    link.type = 'image/x-icon';
    link.href = SUPER_ADMIN_FAVICON;
}

export { SUPER_ADMIN_TITLE, SUPER_ADMIN_FAVICON };
